<template>
	<div class="poll-close-state">
		<ClockIcon type="regular" />
		<span v-if="isOpen">
			{{ t('polls_status_closes_in') }}
			<Tippy v-if="poll.closes_at" :content="$m(poll.closes_at).format('lll')"
				><RelativeTime :date="poll.closes_at" @tick="onTimeTick"
			/></Tippy>
		</span>
		<span v-if="isProcessing">
			{{ t('polls_status_processing') }}
		</span>
		<span v-if="isClosed">
			{{ t('polls_status_closed') }}
		</span>
	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { ClockIcon } from '@/icons'
import { Tippy, RelativeTime } from '@/components/common'
import { getPoll } from '@/store/messages'
import moment from 'moment'
import { useEventBus } from '@/helpers/bus'
import { pollStates as states } from '@/helpers/constants'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
	pollId: {
		type: [Number, String],
		required: true,
	},
})
const emit = defineEmits(['tick', 'poll-change', 'state-change'])

const poll = ref(getPoll(props.pollId) || {})
const state = ref(getCurrentState())
const isClosed = computed(() => state.value === states.CLOSED)
const isProcessing = computed(() => state.value === states.PROCESSING)
const isOpen = computed(() => state.value === states.OPEN)

useEventBus('poll-change', (pollId) => {
	if (pollId === props.pollId) {
		poll.value = { ...getPoll(pollId) }
		emit('poll-change', poll.value)
		state.value = getCurrentState()
	}
})

watch(state, () => {
	emit('state-change', state.value)
})

onMounted(() => {
	emit('state-change', state.value)
})

function getCurrentState() {
	if (poll.value?.closed) return states.CLOSED
	if (moment().isAfter(poll.value?.closes_at)) return states.PROCESSING
	return states.OPEN
}

function onTimeTick(value) {
	state.value = getCurrentState()
	emit('tick', value)
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.poll-close-state {
	@include flex(8px);
	font-size: 14px;
	color: var(--neutral-600);
}
</style>
